import { ReplyApi } from 'api/ApiHelper';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useLikeReplyMutation = (id: number, options: UseMutationOptions) =>
  useMutation({ mutationFn: () => ReplyApi.likeReply(id), ...options });
